// extracted by mini-css-extract-plugin
module.exports = {"Apertura2Notas-parent":"styles_Apertura2Notas-parent__wFhKs","primer-bloque":"styles_primer-bloque__blICw","segundo-bloque":"styles_segundo-bloque__QMO_Y"};